/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { UntypedFormControl } from '@angular/forms';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ContentState } from 'src/app/store/state/content.state';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'u4-cpp-input-error',
    templateUrl: './input-error.component.html',
    styles: []
})
export class InputErrorComponent implements OnInit, OnDestroy {

    @Input() control: UntypedFormControl;

    public labels: {[key: string]: string};
    private destroy$: Subject<void> = new Subject();

    constructor(
        private store: Store<ContentState>
    ) {}

    ngOnInit() {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => this.labels = labels);
    }

    showError(errors: UntypedFormControl['errors']): string {
        switch (Object.keys(errors)[0]) {
        case 'minlength' :
            return this.labels['dashboard.wizard.error.min-length'].replace('{{number}}', errors.minlength.requiredLength);
        case 'required' :
            return this.labels['forms.validation.error.required'];
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
